/* eslint no-irregular-whitespace: 0 */
<template>
  <div
    :class="['nav-container', expandedClass, mobileClass]"
    @mouseover="mouseEntered()"
    @mouseleave="mouseLeft()"
    @click="tapped()"
    id="nav"
  >
    <div class="nav">
      <svg
        class="mask-svg"
        width="1"
        height="1"
        viewBox="0 0 1 1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <clipPath id="rounnerMask" clipPathUnits="objectBoundingBox">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.6312 0C0.743276 0 0.827051 0.0251429 0.887172 0.0765714C0.952503 0.132286 0.985591 0.215429 0.985591 0.323714V0.957143C0.985591 0.980857 0.966724 1 0.943351 1H0.0422396C0.018867 1 0 0.980857 0 0.957143V0.0428571C0 0.0191429 0.018867 0 0.0422396 0H0.6312Z"
            fill="#FEF9F1"
          />
        </clipPath>
      </svg>
      <div class="nav-grid">
        <div
          class="nav-area"
          @mouseover="setArea('1')"
          @click.stop="goTo('1')"
          id="navbox-auditorium"
        >
          <Shape shape="hexagon" :filled="isFilled('1')"></Shape>
          <div class="nav-area-title"><p>Auditorium</p></div>
        </div>
        <div
          class="nav-area"
          @mouseover="setArea('2')"
          @click.stop="goTo('2')"
          id="navbox-theory"
        >
          <Shape shape="triangle" :filled="isFilled('2')"></Shape>
          <div class="nav-area-title"><p>On Schoolscapes</p></div>
        </div>
        <div
          class="nav-area"
          @mouseover="setArea('3')"
          @click.stop="goTo('3')"
          id="navbox-placemaking"
        >
          <Shape shape="rounner" :filled="isFilled('3')"></Shape>
          <div class="nav-area-title"><p>Placemaking</p></div>
        </div>
        <div
          class="nav-area"
          @mouseover="setArea('4')"
          @click.stop="goTo('4')"
          id="navbox-traversing"
        >
          <Shape shape="circle" :filled="isFilled('4')"></Shape>
          <div class="nav-area-title"><p>Traversing</p></div>
        </div>
      </div>

      <div class="nav-center" v-if="expanded == true">
        <!-- <transition name="slide-fade" mode="out-in"> -->
        <p key="1" v-if="selectedArea == '1'" class="nav-center-text">
          Auditorium
        </p>
        <p key="2" v-else-if="selectedArea == '2'" class="nav-center-text">
          Building Schoolscapes
        </p>
        <div key="3" v-else-if="selectedArea == '3'" class="nav-center-text">
          <p>Placemaking the Campus</p>
        </div>
        <div key="4" v-else-if="selectedArea == '4'" class="nav-center-text">
          <p>Traversing the Campus</p>
        </div>
        <!-- </transition> -->
      </div>

      <div
        class="nav-lines"
        :style="{ '--navX': navX + 'px', '--navY': navY + 'px' }"
      >
        <div class="vertical"></div>
        <div class="horizontal"></div>
        <!-- <div class="circle"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Shape from "@/components/Shape.vue";

export default {
  name: "NavRounner",
  components: {
    Shape,
  },
  data() {
    return {
      expanded: false,
      selectedArea: null,
      // activeArea: null,
      resetInterval: null,
      navX: 0,
      navY: 0,
      mobileBreakpoint: 480,
    };
  },
  computed: {
    expandedClass() {
      if (this.expanded == true) {
        return "nav--is-expanded";
      } else {
        return "";
      }
    },
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint ? true : false;
    },
    mobileClass() {
      return window.innerWidth <= this.mobileBreakpoint ? "nav-is--mobile" : "";
    },
    activeArea() {
      let activePath = this.$route.path.replace("/", "");
      if (activePath === "") {
        activePath = "auditorium";
      }

      let areaNum = 0;
      switch (activePath) {
        case "auditorium":
          areaNum = 1;
          break;
        case "theory":
          areaNum = 2;
          break;
        case "placemaking":
          areaNum = 3;
          break;
        case "traversing":
          areaNum = 4;
          break;
        default:
          break;
      }

      return areaNum;
    },
  },
  methods: {
    tapped() {
      if (!this.isMobile) {
        return;
      }

      if (this.isMobile && !this.expanded) {
        this.expanded = true;
      }
    },
    setArea(areaNum) {
      this.selectedArea = areaNum;
      this.$store.dispatch("playNudge");
    },
    goTo(pageNum) {
      // only use action on mobile if expanded
      if (this.isMobile && !this.expanded) {
        return;
      }

      let tryPlayingSoundscape = true;
      let page = "/";
      switch (pageNum) {
        case "1":
          page += "";
          break;
        case "2":
          page += "theory";
          break;
        case "3":
          page += "placemaking";
          break;
        case "4":
          page += "traversing";
          break;
        default:
          break;
      }

      if (tryPlayingSoundscape) {
        this.$store.dispatch("playSoundscape");
      }

      this.$store.dispatch("prepareToNavigate", {
        from: this.$route.path,
        to: page,
        position: window.scrollY,
      });
      this.$router.push(page);

      this.$store.dispatch("playBell");

      if (this.isMobile) {
        // this.expanded = false;
        this.mouseLeft();
      }

      // this.activeArea = pageNum;
    },
    resetLines() {
      let active = this.$route.path.replace("/", "");
      if (active === "") {
        active = "auditorium";
      }

      let activeBox = document.querySelector("#navbox-" + active);

      if (activeBox == undefined) {
        this.navX = -10;
        this.navY = -10;
      } else {
        let { x, y } = this.getElementCenter(activeBox);
        this.navX = x;
        this.navY = y;
      }
    },
    getElementCenter(element) {
      // Get the element's offset from its parent
      const offsetLeft = element.offsetLeft;
      const offsetTop = element.offsetTop;

      // Get the element's width and height
      const width = element.offsetWidth;
      const height = element.offsetHeight;

      // Calculate the center coordinates
      const x = offsetLeft + width / 2;
      const y = offsetTop + height / 2;

      // Return the center coordinates as an object
      return { x, y };
    },
    mouseLeft() {
      // if (this.isMobile) {
      //   return;
      // }
      this.expanded = false;
      this.selectedArea = null;
      this.resetInterval = setInterval(() => {
        this.resetLines();
      }, 1);

      setTimeout(function () {
        clearInterval(this.resetInterval);
      }, 300);
    },
    mouseEntered() {
      if (this.isMobile) {
        return;
      }

      this.expanded = true;
      clearInterval(this.resetInterval);
    },
    isFilled(num) {
      if (this.activeArea == num) {
        return true;
      }

      if (this.selectedArea == num) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    // document.addEventListener("click", (e) => {
    //   console.log(e);
    //   console.log(e.currentTarget);
    //   console.log(e.target);
    // });
    let navEl = document.querySelector(".nav-container");

    // Listen for mouse to set x and y coords
    if (!this.isMobile) {
      navEl.addEventListener("mousemove", (e) => {
        let mousePageX = e.pageX;
        let mousePageY = e.pageY;
        let navBox = navEl.getBoundingClientRect();
        let navX = navBox.x;
        let navY = navBox.y;

        const x = mousePageX - navX;
        const y = mousePageY - navY;
        this.navX = x;
        this.navY = y;
      });
    }

    this.mouseLeft();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.nav-container {
  filter: drop-shadow(0px 4.38857px 14.2629px rgba(114, 74, 13, 0.25));
  position: fixed;
  top: 24px;
  right: 24px;
  height: 94px;;
  width: 94px;
  z-index: 10000;

  /* transition: all 350ms ease-in-out; */
  transition: all 400ms cubic-bezier(0.22, 0.82, 0.46, 1.01);
}

.nav-container.nav-is--mobile {
  height: 80px;
  width: 80px;
}

.nav {
  position: relative;
  height: 100%;
  width: 100%;
  /* overflow: hidden; */
  background: #FDF8F0;

  /* styles pulled from figma */
  /* border: 1.09714px solid #F0E0C7; */
  box-shadow: inset 0px 6.58286px 14.2629px rgba(255, 255, 255, 0.6);
  /* filter: blur(1.09714px); */
  /* border-radius: 39.4971px; */

  -webkit-clip-path: url(#rounnerMask);
  clip-path: url(#rounnerMask);
  /* background: blue; */
}

.nav-container.nav--is-expanded {
  height: 300px;
  width: 300px;
  z-index: 100000;
}

.nav-container.nav--is-expanded.nav-is--mobile {
  height: calc(100vw - 24px - 28px);
  width: calc(100vw - 24px - 28px);
}

.nav-container .nav-area {
  pointer-events: none;
}

.nav-container.nav--is-expanded .nav-area {
  pointer-events: all;
  cursor: pointer;
}

.nav-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  height: 100%;
  width: 100%;
  z-index: 10;
}

.nav-area {
  /* border: 1px solid black; */
  display: grid;
  /* ????? dunno why this works rn  */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  position: relative;
  transition: transform 200ms var(--motion-bubblier-bezier);
}

.nav-area .shape-svg {
  transform: scale(1);
  transition: transform 200ms var(--motion-bubblier-bezier);
}

.nav-area:active .shape-svg {
  transform: scale(0.7);
}

.nav-center {
  position: absolute;
  width: 100%;
  text-align: center;
  pointer-events: none;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0px 0px 2px 1px var(--tan-01); */
}

.nav-center .nav-center-text {
  position: absolute;
  transform: scale(1);
  opacity: 1;
  transition: all 300ms var(--motion-bubbly-bezier);
}

.nav-container.nav--is-expanded.nav-is--mobile .nav-center {
  display: none;
}

.nav-container .nav-area .nav-area-title {
  display: none;
}

.nav-container.nav-is--mobile .nav-area .nav-area-title {
  display: block;
  width: 100%;
  position: absolute;
  text-align: center;
  pointer-events: none;
  bottom: 0.6rem;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: var(--motion-primary);
  transition-delay: 0ms;
  text-shadow: -1px 2px 0px rgb(253 248 240);
}

.nav-container.nav--is-expanded.nav-is--mobile .nav-area .nav-area-title {
  opacity: 1;
  transition-delay: 200ms;
}

.nav-lines {
  position: absolute;
  height: 100%;
  width: 100%;
  pointer-events: none;
  top: 0;
  left: 0;
}

.nav-lines .vertical {
  position: absolute;
  transform: translateX(var(--navX));
  height: 100%;
  width: 2px;
  background: var(--tan-lines);
}

.nav-lines .horizontal {
  position: absolute;
  transform: translateY(var(--navY));
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--tan-lines);
}

.nav-lines .circle {
  --borderWidth: 0px;
  --circleSize: 40px;
  --circleX: calc(var(--navX) - (var(--circleSize) / 2) - var(--borderWidth));
  --circleY: calc(var(--navY) - (var(--circleSize) / 2) - var(--borderWidth));
  position: absolute;
  transform: translate(var(--circleX), var(--circleY));
  height: var(--circleSize);
  width: var(--circleSize);
  /* border: 2px solid var(--tan-lines); */
  background: radial-gradient(var(--tan-01), transparent);
  opacity: 0.98;
  border-radius: 20px;
}





.nav .mask-svg {
  position: absolute;
  pointer-events: none;
}
</style>
